'use client'

import React, { ReactNode } from 'react'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import VideoPlayer from '@/components/Refresh/VideoPlayer/VideoPlayer'
import InactivityModal from '@/components/Refresh/Modals/InactivityModal/InactivityModal'
import BaseModal from '@/components/Refresh/Modals/BaseModal/BaseModal'

interface VideoModalProps {
    type: 'video'
    isOpen: boolean
    close: () => void
    videoUrl: string
}

interface GenericModalProps {
    type: 'generic'
    isOpen: boolean
    close: () => void
    children: ReactNode
    maxWidth?: string | number
}

interface InactivityModalProps {
    type: 'inactivity'
    isOpen: boolean
    close: () => void
    children: ReactNode
}

type ModalManagerProps = VideoModalProps | GenericModalProps | InactivityModalProps

export default function ModalManager(props: ModalManagerProps) {
    const { isSm } = useBreakpoint()
    const zIndex = 100

    switch (props.type) {
        case 'video':
            return (
                <VideoPlayer
                    opened={props.isOpen}
                    onClose={props.close}
                    videoUrl={props.videoUrl}
                    isSm={!!isSm}
                    zIndex={zIndex}
                />
            )
        case 'inactivity':
            return (
                <InactivityModal opened={props.isOpen} onClose={props.close} zIndex={zIndex}>
                    {props.children}
                </InactivityModal>
            )
        case 'generic':
            return (
                <BaseModal opened={props.isOpen} onClose={props.close} zIndex={zIndex} maxWidth={props.maxWidth}>
                    {props.children}
                </BaseModal>
            )
        default:
            return null
    }
}
